import type { OrgLimits } from "@/lib/api/organizations";

/// Why the caller cannot create another non-personal org, in the words the button's
/// tooltip and the create page's banner both use — one place, so they cannot
/// disagree about the count.
export function orgCreateRefusal(limits: OrgLimits | null): string | null {
  if (!limits || limits.can_create_free_org) return null;
  return `You already own ${limits.owned_free_orgs} of ${limits.max_free_orgs} free organizations. Upgrade one, or delete one you no longer need.`;
}
